import { systemIds } from '@/shared/utils';
import { getRiskToPathName } from './getRiskToPathName';
// 采购寻源
const commonScmPurchaseFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-purchase'], // 为了获取基础路由
    };
};
const scmPurchase = {
    // 询价单采购方详情
    scm10101: ({ businessKey }) => commonScmPurchaseFunc(`/purchaser/inquiry/detail?id=${businessKey}`),
    // 询价单销售方详情
    scm10102: ({ businessKey }) => commonScmPurchaseFunc(`/supplier/supplierInquiry/detail?id=${businessKey}`),
    // 报价单采购方详情
    scm10201: ({ businessKey }) => commonScmPurchaseFunc(`/purchaser/purchaserQuotation/detail?id=${businessKey}`),
    // 报价单销售方详情
    scm10202: ({ businessKey }) => commonScmPurchaseFunc(`/supplier/quotation/detail?id=${businessKey}`),
};
// 合同协同
const commonScmContractFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-contract'], // 为了获取基础路由
    };
};
const scmContract = {
    // 采购合同详情
    scm104011: ({ businessKey }) => commonScmContractFunc(`/purContract/contract/detail?id=${businessKey}`),
    // 确认销售方合同详情
    scm104021: ({ businessKey }) => commonScmContractFunc(`/purContract/purQutContract/detailEdit?id=${businessKey}`),
    // 确认采购方合同详情
    scm104012: ({ businessKey }) => commonScmContractFunc(`/supContract/supInqContract/detailEdit?id=${businessKey}`),
    // 销售合同详情
    scm104022: ({ businessKey }) => commonScmContractFunc(`/supContract/contract/detail?id=${businessKey}`),
};
// const userInfoJson = userInfo;
// if (userInfoJson && userInfoJson.defaultCompId === variables.companyId) {
//   return base.scmUrlBill + `/initiate/detail?id=${t.businessKey}`;
// } else {
//   return base.scmUrlBill + `/confirm/detail?id=${t.businessKey}`;
// }
// 账单协同
const scmBill = {
    // 账单详情页
    settle10400: ({ businessKey }) => ({
        path: `/initiate/detail?id=${businessKey}`,
        systemId: systemIds['scm-bill'],
    }),
};
// 结算协同
const commonScmSettleFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-settle'], // 为了获取基础路由
    };
};
const scmSettle = {
    // 供应商接收/拒绝应付结算单
    settle103011: ({ businessKey }) => commonScmSettleFunc(`/sup_bill/settlement/handle/detail?id=${businessKey}`),
    // 客户接收/拒收应收结算单
    settle103022: ({ businessKey }) => commonScmSettleFunc(`/pur_bill/settlement/receivable/detail?id=${businessKey}`),
    // 核销应付结算单完成
    settle103012: ({ businessKey }) => commonScmSettleFunc(`/pur_bill/accept/handle/detail?id=${businessKey}`),
    // 核销应收结算单完成
    settle103021: ({ businessKey }) => commonScmSettleFunc(`/sup_bill/accept/receivable/detail?id=${businessKey}`),
    riskWarning1010_settle1030_1: getRiskToPathName,
    riskWarning1010_settle1030_2: getRiskToPathName,
    riskWarning1020_settle1030_1: getRiskToPathName,
    riskWarning1020_settle1030_2: getRiskToPathName,
    riskWarning1030_settle1030_1: getRiskToPathName,
    riskWarning1030_settle1030_2: getRiskToPathName,
    riskWarning1040_settle1030_1: getRiskToPathName,
    riskWarning1040_settle1030_2: getRiskToPathName,
};
// 资金往来，付款
const scmPay = {
    // 供应商接收/拒绝进项发票
    settle10101: ({ businessKey }) => ({
        path: `/pur-capital-flow/pay/-detail?id=${businessKey}`,
        systemId: systemIds['scm-settle-finance'],
    }),
};
// 发票协同
const commonScmInvoiceFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-settle-invoice'], // 为了获取基础路由
    };
};
const scmInvoice = {
    // 供应商接收/拒绝进项发票
    settle106011: ({ businessKey }) => commonScmInvoiceFunc(`/pur-invoice/income/-detail?id=${businessKey}`),
    // 客户接收/拒绝进项发票
    settle106022: ({ businessKey }) => commonScmInvoiceFunc(`/sup-invoice/output/-detail?id=${businessKey}`),
};
// 交易协同
const commonScmTransactionFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-order'], // 为了获取基础路由
    };
};
const scmTransactionCoordination = {
    // 发货通知单审批通过后提交给采购方
    logistic10101: ({ businessKey }) => commonScmTransactionFunc(`/purOrder/shipmentsNotice/detail?id=${businessKey}`),
    // 发货通知单接收/拒接
    logistic10102: ({ businessKey }) => commonScmTransactionFunc(`/supOrder/shipmentsNotice/detail?id=${businessKey}`),
    // 销售发货单审批通过后提交到采购方
    logistic10201: ({ businessKey }) => commonScmTransactionFunc(`/supOrder/shipments/detail?id=${businessKey}`),
    // 根据发货单生成的采购收货单审批通过后
    logistic10202: ({ businessKey }) => commonScmTransactionFunc(`/purOrder/shipments/detail?id=${businessKey}`),
    // 采购退货单被签收/拒收
    logistic10301: ({ businessKey }) => commonScmTransactionFunc(`/purOrder/return/detail?id=${businessKey}`),
    // 根据发货单生成的采购退货单审批通过后
    logistic10302: ({ businessKey }) => commonScmTransactionFunc(`/supOrder/purchaseReturn/detail?id=${businessKey}`),
    // 采购订单审批通过提交给供货方
    scm106012: ({ businessKey }) => commonScmTransactionFunc(`/supOrder/purOrder/detailEdit?id=${businessKey}`),
    // 采购订单供应商确认接收/拒接
    scm106011: ({ businessKey }) => commonScmTransactionFunc(`/purOrder/orderTable/detail?id=${businessKey}`),
    // 销售订单审批通过后提交给客户
    scm106021: ({ businessKey }) => commonScmTransactionFunc(`/purOrder/supOrder/detailEdit?id=${businessKey}`),
    // 销售订单客户方接单
    scm106022: ({ businessKey }) => commonScmTransactionFunc(`/supOrder/orderTable/detail?id=${businessKey}`),
};
// 尽职调查
const commonScmBasicFunc = (path) => {
    return {
        path,
        systemId: systemIds['scm-basic'], // 为了获取基础路由
    };
};
const scmBasic = {
    // 上传尽调
    scm20501: ({ businessKey }) => commonScmBasicFunc(`/diligence/upload-material/-detail?id=${businessKey}`),
    // 接收尽调上传
    scm20502: ({ businessKey }) => commonScmBasicFunc(`/diligence/accepts/-detail?id=${businessKey}`),
};
export const scmOtherToPathNameMap = {
    ...scmPurchase,
    ...scmContract,
    ...scmBill,
    ...scmSettle,
    ...scmPay,
    ...scmInvoice,
    ...scmTransactionCoordination,
    ...scmBasic,
};
